const SLATE_EDITOR_REPLACEMENT_SELECTION = {
    end: 'end',
    start: 'start',
    preserve: 'preserve',
    none: 'none',
} as const;

export default SLATE_EDITOR_REPLACEMENT_SELECTION;
